import { post } from './httpUtil';
import { SEND_UI_EVENT } from '../constants/api';

export const onClickWrapper = (identity, handler) => (event) => {
  const id = identity === null ? event.nativeEvent.target.id : identity;
  post(SEND_UI_EVENT(id, encodeURIComponent(window.location.href)), {});
  if (handler) {
    handler(event);
  }
};
